import React from 'react';

import AddProductPageView from './view';
import { useHistory } from "react-router-dom";
import ModalDetail from '../../components/modalCustom';
import DataGetUsmh from "../../services/addproduct";
import ModalConfirm from '../../components/modalConfirms';
import Products from "../../services/addproduct";
import { useKana } from 'react-use-kana';
import Fuse from "fuse.js";
import moment from 'moment';

const AddProductPage = () => {

    let history = useHistory();
    // var convert = require("jp-conversion");
    const yourDate = new Date();
    const dateFroms = moment().subtract(30, 'days');
    const localStorageParamUrl = {
        account_id: localStorage.getItem('account_id'),
        company_code: localStorage.getItem('company_code'),
        store_code: localStorage.getItem('store_code'),
        instore_code: localStorage.getItem('instore_code'),
        area_code: localStorage.getItem('area_code'),
        timerange_code: localStorage.getItem('timerange_code')
    };
    const [inputValue, setInputValue] = React.useState(1);
    const [inputHistory, setInputHistory] = React.useState(1);
    const [dataInit, setDataInit] = React.useState(1);
    const [dataInitInput, setDataInitInput] = React.useState(1)
    const [janCode, setJanCode] = React.useState('');
    const [categoryId, setCategoryId] = React.useState('');
    const [idPrd, setIdPrd] = React.useState('');
    const [idPrdHistory, setIdPrdHistory] = React.useState('');
    const [packingSpecHistory, setPackingSpecHistory] = React.useState(1);
    const { kana, setKanaSource } = useKana({ kanaType: 'katakana' });
    const [visible, setVisible] = React.useState(false);
    const [visibleHistory, setVisibleHistory] = React.useState(false);
    const [visibleUpdate, setVisibleUpdate] = React.useState(false);
    const [visibleScanFail, setVisibleScanFail] = React.useState(false);
    const [isScans, setIsScans] = React.useState(false);
    const [isInput, setIsInput] = React.useState(false);
    const [isLogHistory, setIsLogHistory] = React.useState(false);
    const [barcode, setBarcode] = React.useState('');
    const [barcodeReScan, setBarcodeReScan] = React.useState([]);
    const [values, setValue] = React.useState({ dataValue: [] });
    const account_id = localStorage.getItem('account_id');
    const [isScrollTop, setIsScrollTop] = React.useState(0);
    const [allProduct, setAllProduct] = React.useState([]);
    const [activeKey, setActiveKey] = React.useState(0);
    const [dataImg, setDataImg] = React.useState([]);
    const [itemsAll, setItemsAll] = React.useState([]);
    const [indexSlice, setIndexSlice] = React.useState(6);
    const [searchData, setSearchData] = React.useState([]);
    const [searchDataCateGory, setSearchDataCateGory] = React.useState([]);
    const [querys, setQuery] = React.useState(false);
    const [searched, setSearched] = React.useState(true);
    const [dataSelectCategory, setDataSelectCategory] = React.useState([]);
    const [dataSelectScanned, setDataSelectScanned] = React.useState([]);
    const [choosePrd, setChoosePrd] = React.useState(false);
    const [isAddCateToList, setIsAddCateToList] = React.useState(false);
    const [isAddScanToList, setIsAddScanToList] = React.useState(false);
    const [callBackProduct, setCallBackProduct] = React.useState(0);
    const [dataDfQuery, setDataDfQuery] = React.useState('');
    const [dateFrom, setDateFrom] = React.useState(dateFroms.toISOString().split('T')[0]);
    const [dateTo, setDateTo] = React.useState(yourDate.toISOString().split('T')[0]);
    const [dataHistory, setDataHistory] = React.useState([]);
    const [isSearchHistory, setIsSearchHistory] = React.useState(0);
    const [dataImgHistory, setDataImgHistory] = React.useState([]);

    // console.log("===> kana:", kana);

    // var res = convert.convert("刺身");
    // console.log(res);

    React.useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    React.useEffect(() => {

        if (!barcode) return;
        setDataSelectScanned(value => {
            const list = value
                .filter((item) => item.jan_code !== barcode)
                .concat({
                    jan_code: barcode,
                    isSubmit: false,
                    product_name: '見つかりませんでした。',
                    purchase_count: 1,
                    packing_spec_df: 1,
                    // count:1,
                    dataScan: true
                });

            return list;
        })

        DataGetUsmh.getUsmh(
            { ...localStorageParamUrl, item_code: barcode },
            (res) => {
                if (res.result && res.result === 'success') {
                    if (res.data !== null) {
                        setDataSelectScanned(value => {
                            const list = value
                                .filter((item) => item.jan_code !== barcode)
                                .concat({
                                    ...res.data,
                                    count:1,
                                    purchase_count: 1,
                                    packing_spec_df: res?.data?.packing_spec ? res.data.packing_spec : 1,
                                    dataScan: true
                                });

                            return list;
                        })
                    };
                }
            }
        );
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [barcode]);

    React.useEffect(() => {

        if(barcodeReScan?.length<1) return;
    
        let dataNew = [...dataSelectScanned]

        for( const item_barcode of dataNew){

            if( barcodeReScan.filter((item) => item === item_barcode.jan_code).length>0){
                item_barcode.count = barcodeReScan.filter((item) => item === item_barcode.jan_code).length
            }else{
                item_barcode.count =1
            }
        };

        setDataSelectScanned(dataNew);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [barcodeReScan]);

    React.useEffect(() => {

        if (allProduct.length === 0) {

            Products.getAllProducts(
                localStorageParamUrl,
                (res) => {
                    if (res.result === 'success' && res.data?.length) {

                        setAllProduct(res.data?.map(item => {
                            return {
                                ...item,
                                category_child: item.category_child?.map(itemChild => {
                                    return {
                                        ...itemChild,
                                        product_list: itemChild?.product_list?.map(itemPrd => {
                                            return {
                                                ...itemPrd,
                                                isChoose: false,
                                                purchase_count: 1,
                                                packing_spec_df: itemPrd.packing_spec ? itemPrd.packing_spec : 1,
                                                packing_spec: itemPrd.packing_spec ? itemPrd.packing_spec : 1
                                            }
                                        })
                                    }
                                })
                            }
                        }));

                        let dataValue = [];
                        const allProduct = res.data
                        if (allProduct.length) {
                            for (const items of allProduct) {
                                if (items?.category_child?.length > 0) {
                                    for (const itemCategory of items.category_child) {
                                        if (itemCategory?.product_list?.length > 0) {
                                            for (const itemChild of itemCategory.product_list) {
                                                dataValue.push(itemChild);
                                            }
                                        }
                                    }
                                }
                            }
                        };
                        setItemsAll(dataValue);
                    };
                }
            )
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [callBackProduct]);

    React.useEffect(() => {

        if (searchDataCateGory.length > 0 && searchData.length > 0) {

            setAllProduct((value) => {
                const list = [...value];

                for (const item of list) {

                    if (searchDataCateGory.filter(item_filter => item_filter?.item?.category_id === item.category_id).length > 0) {
                        item.isShowTabs = true;
                    } else {
                        item.isShowTabs = false;
                    };

                    if (item.category_child?.length > 0) {
                        for (const itemCategory of item.category_child) {
                            let data = []
                            if (itemCategory?.product_list?.length > 0) {
                                for (const itemProduct of itemCategory.product_list) {
                                    for (const itemSearch of searchData) {
                                        itemSearch.item.packing_spec = itemSearch.item.packing_spec? itemSearch.item.packing_spec: 1;
                                        itemSearch.item.packing_spec_df = itemSearch.item.packing_spec_df? itemSearch.item.packing_spec_df: 1;
                                        if (
                                            itemProduct.id === itemSearch?.item?.id
                                            && itemProduct.jan_code === itemSearch?.item?.jan_code
                                            && itemProduct.category_id === itemSearch?.item?.category_id
                                        ) {
                                            data.push(itemSearch.item);
                                        }
                                    }
                                }
                            };
                            itemCategory.product_list_search = data;
                        }
                    }

                    // dataIsShow = true;
                }

                return list;
            })
        };

    }, [searchDataCateGory, searchData]);

    React.useEffect(() => {

        let dataValueInput = [];
        if (allProduct.length) {
            for (const items of allProduct) {
                if (items?.category_child?.length > 0) {
                    for (const itemCategory of items.category_child) {
                        if (itemCategory?.product_list?.length > 0) {
                            for (const itemChild of itemCategory.product_list) {
                                if (itemChild.isChoose === true) {
                                    dataValueInput.push(itemChild);
                                }
                            }
                        }
                    }
                }
            }
        };

        setDataSelectCategory(Array.from(new Set(dataValueInput)).filter(item => item.isChoose));
    }, [allProduct]);

    React.useEffect(() => {
        Products.getHistoryPrd(
            {
                account_id: account_id,
                from: dateFrom,
                to: dateTo
            },
            (res) => {
                if (res.result && res.result === 'success') {

                    const dataGet = res.data.map(item=>{
                        return {
                            ...item, 
                            packing_show:(item.packing_spec*item.purchase_count)? 
                                Math.round((item.packing_spec*item.purchase_count) * 100)/100 : 1
                        }
                    });

                    if(res?.data.length === 0){
                        setDataHistory(null);
                    };

                    const dataTree = [];
                    const result = []
                    // const checkExist = (needForCheck) => needForCheck === undefined || needForCheck === null;
                    const checkExist = (needForCheck) => !needForCheck

                    dataGet.forEach(item => {
                    
                        if(checkExist(dataTree[item.purchase_date.slice(0, 10)])) {
                            dataTree[item.purchase_date.slice(0, 10)] = [];
                        }
        
                        dataTree[item.purchase_date.slice(0, 10)] = [
                            ...dataTree[item.purchase_date.slice(0, 10)], item
                        ]
                    })

                    for(const item in dataTree){
                        result.push({
                            date: item,
                            child: dataTree[item].sort(function(a, b){return a.id - b.id})
                        })
                    }

                    setDataHistory(result.reverse());

                    const dataGetImg = dataGet
                        .map(v => v['item_code'])
                        .map((v, i, array) => array.indexOf(v) === i && i)
                        .filter(v => dataGet[v])
                        .map(v => dataGet[v])
                        .map(item => {
                            return {
                                item_code: item.item_code? item.item_code:""
                            }
                        });
                    
                    getImgHistory(dataGetImg);
 
                } else{
                    setDataHistory(null);
                    console.log(res);
                }
            }
        );
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSearchHistory]);

    React.useEffect(() => {
        
        handleSearchCategory(dataDfQuery, kana);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    },[dataDfQuery, kana]);

    const getImgHistory = React.useCallback((data) => {

        if (data?.length === 0) return;
        return (
            DataGetUsmh.getImgProduct(
                { ...localStorageParamUrl, list_jancode: data },
                (res) => {

                    if (res?.result === 'success') {
                        if(res?.data?.data?.length <1) return;
                        setDataImgHistory(res.data.data);
                    };
                    if (res.result && res.result === 'failure') {
                        // setDataImg([]);
                    };
                }
            )
        )
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const submitChangeHistory=(dataJc, categoryId, idPrd, dataModal)=>{

        const purchase_history = dataModal / (packingSpecHistory * 100);
        
        Products.updatePrdHistory(
            {
                id:idPrd,
                account_id: account_id,
                purchase_count: purchase_history
            },
            (res) => {

                if (res.result && res.result === 'success') {
                    setIsSearchHistory(isSearchHistory +1)
                } else{
                    console.log(res);
                };
                setVisibleHistory(false);
            }
        );
    }

    const deleteHistory =(value)=>{
        Products.updatePrdHistory(
            {
                id:value?.id,
                account_id: account_id,
                purchase_count: 0
            },
            (res) => {
                if (res.result && res.result === 'success') {
                    setIsSearchHistory(isSearchHistory +1)
                } else{
                    console.log(res);
                };
            }
        );
    }

    const showDetailPrdHistory = (value) => {
        setVisibleHistory(true);
        setInputHistory( Math.round((value?.packing_show * 100) * 100) / 100);
        setDataInitInput(Math.round((value?.packing_show * 100) * 100) / 100);
        setIdPrdHistory(value.id)
        setPackingSpecHistory(value.packing_spec?value.packing_spec :1)
    };

    const getImgUrlProduct = React.useCallback((data) => {

        if (data.length === 0) return;
        return (
            DataGetUsmh.getImgProduct(
                { ...localStorageParamUrl, list_jancode: data },
                (res) => {
                    if (res.result && res.result === 'success') {
                        if (res?.data?.data?.length > 0) {
                            setDataImg((value) => value.concat(...res.data.data.filter(item_img => item_img.image_url)));
                        };
                    };
                    if (res.result && res.result === 'failure') {
                        // setDataImg([]);
                    };
                }
            )
        )
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [indexSlice]);

    const showDetailProduct = (value) => {
        setVisible(!visible);
        setInputValue( Math.round((value?.packing_spec * 100) * 100) / 100);
        setDataInit(Math.round((value?.packing_spec * 100) * 100) / 100);
        setJanCode(value.jan_code);
        setCategoryId(value.category_id)
        setIdPrd(value.id)
    };

    const submitChangePacking = (dataJc, categoryId, idPrd, dataModal) => {

        setValue((value) => {
            const list = [...value.dataValue]
            for (const item of list) {
                if (item.jan_code === dataJc && item.category_id === categoryId) {
                    // alert(dataModal / 100)
                    item.purchase_count = dataModal / (item.packing_spec_df * 100);
                    item.packing_spec = dataModal / 100;
                    setDataInit(dataModal / 100);
                }
            };
            return {
                dataValue: list
            };
        });

        setAllProduct((value) => {
            const list = [...value]
            for (const item of list) {
                for (const itemCategory of item.category_child) {
                    for (const itemChild of itemCategory.product_list) {
                        if (itemChild.jan_code === dataJc
                            && itemChild.category_id === categoryId
                            && itemChild.id === idPrd
                        ) {
                            itemChild.purchase_count = dataModal / (itemChild.packing_spec_df * 100);
                            itemChild.packing_spec = dataModal / 100;
                            itemChild.isChoose = true;
                            setDataInit(dataModal / 100);
                        }
                    }

                    if (itemCategory.product_list_search?.length > 0) {
                        for (const itemChild of itemCategory.product_list_search) {
                            if (itemChild.jan_code === dataJc
                                && itemChild.category_id === categoryId
                                && itemChild.id === idPrd
                            ) {
                                itemChild.purchase_count = dataModal / (itemChild.packing_spec_df * 100);
                                itemChild.packing_spec = dataModal / 100;
                                itemChild.isChoose = true;
                                setDataInit(dataModal / 100);
                            }
                        }
                    }
                }
            }
            return list;
        });

        setVisible(false);
    };

    const deleteItemProduct = (data, scan) => {

        if (scan === 'IS_SCAN') {
            setDataSelectScanned(value => {
                const list = value.filter((item) => item.jan_code !== data.jan_code)
                return list;
            });

            let newArr = [...barcodeReScan]
            let list = newArr.filter(item_scan => item_scan !== data.jan_code);
            setBarcodeReScan(list);
        } else {
            setValue((value) => {
                const list = value.dataValue.filter((item) => (
                    item.food_code !== data.food_code
                    || item.category_id !== data.category_id
                    || item.id !== data.id
                ))
                return {
                    dataValue: list
                };
            });
        };

        setBarcode('');

        setAllProduct((value) => {
            const list = [...value];
            for (const item of list) {
                for (const itemCategory of item.category_child) {
                    for (const itemChild of itemCategory.product_list) {
                        if (itemChild.jan_code === data.jan_code
                            && itemChild.category_id === data.category_id
                            && itemChild.id === data.id
                        ) {
                            itemChild.isChoose = false;
                            itemChild.packing_spec = itemChild.packing_spec_df ? itemChild.packing_spec_df : 1;
                        }
                    }
                }
            }

            return list;
        });
    };

    const submitUpdateChart = () => {

        const dataValues = Array.from(new Set(values.dataValue));

        const dataAdd = dataValues
            .filter((item) => item.isSubmit !== false
                && item.jan_code
                && item.food_code)
            .map(value => {
                return {
                    purchase_count: value.purchase_count * (value.count ? value.count : 1),
                    item_code: value.jan_code,
                    food_code: value.food_code
                }
            });

        DataGetUsmh.addProducts(
            {
                account_id: account_id,
                item_list: dataAdd
            },
            (res) => {
                setVisibleUpdate(false);
                if (res.result && res.result === 'success') {
                    history.goBack()
                };
                if (res.result && res.result === 'failure') {
                    console.log(res);
                };
            }
        );
    };

    const submitModalScanFail = () => {
        setVisibleScanFail(false);
        setTimeout(
            () => onClickBtnInput(),
            100
        );
    };

    const onClickBtnScan = () => {
        setIsScans(true);
        setIsInput(false);
        setIsAddScanToList(false);
        setIsScrollTop(isScrollTop + 1);
    };

    const onClickBtnInput = () => {
        setIsScans(false);
        setIsInput(true);
        setIsAddCateToList(false);
        setIsScrollTop(isScrollTop + 1);

        if (allProduct.length === 0) {
            setCallBackProduct(callBackProduct + 1);
        };

        if (dataImg.length === 0) {
            let data = []
            for (const itemdata of allProduct) {
                if (itemdata?.category_child?.length > 0) {
                    for (const itemChild of itemdata?.category_child) {
                        if (itemChild.product_list.length > 0) {
                            for (const itemProduct of itemChild.product_list.slice(0, 5)) {
                                data.push({ item_code: itemProduct.jan_code });
                            };
                        };
                    };
                };
            }
            getImgUrlProduct(data);
        };
    };

    const onClickBtnLog = () => {
        setIsLogHistory(true)
    }

    const handleScroll = e => {};

    const handleSearchCategory =(dataDfQuery, kana)=>{
        if (!dataDfQuery) {
            setSearched(true);
            setQuery(false);
        };

        const optionsCategory = {
            tokenize: false,
            findAllMatches: true,
            location:0,
            distance:100,
            threshold:0.3,
            keys: ['category_child.product_list.food_name']
        };

        const options = {
            tokenize: false,
            findAllMatches: true,
            location:0,
            distance:100,
            threshold:0.3,
            // ignoreLocation:true,
            keys: ['food_name']
        };

        const fuseCategory = new Fuse(allProduct, optionsCategory);
        const resultCategory = fuseCategory.search(dataDfQuery);
        const resultCategoryKana = fuseCategory.search(kana);

        const fuse = new Fuse(itemsAll, options);
        const result = fuse.search(dataDfQuery);
        const resultKana = fuse.search(kana);

        // console.log("=====>result:", result);

        if (resultCategory.length && result.length) {

            console.log("=====> search default :", dataDfQuery);
            setSearched(true);
            setQuery(true);
            setSearchData(result);
            setSearchDataCateGory(resultCategory)

            let dataGet = [];
            for (const itemChild of result) {
                dataGet.push({ item_code: itemChild.jan_code });
            };

            getImgUrlProduct(dataGet);

        } else {
            console.log("=====> search kana type:", kana);
            if(resultCategoryKana.length && resultKana.length){
                setSearched(true);
                setQuery(true);
                setSearchData(resultKana);
                setSearchDataCateGory(resultCategoryKana)
    
                let dataGet = [];
                for (const itemChild of resultKana) {
                    dataGet.push({ item_code: itemChild.jan_code });
                };
    
                getImgUrlProduct(dataGet);
            }else{
                setSearchData([]);
                setSearchDataCateGory([])
                if (dataDfQuery.length !== 0) {
                    setSearched(false);
                }
            }
        };
    }

    const onSearchCategory =(query) => {
        setKanaSource(query);
        setDataDfQuery(query);
    };

    const onClickItemProduct = (itemPrd, index3) => {

        if (itemPrd.isChoose) {

            setAllProduct((value) => {
                const list = [...value];

                for (const item of list) {
                    for (const itemCategory of item.category_child) {
                        for (const itemChild of itemCategory.product_list) {
                            if (itemChild.jan_code === itemPrd.jan_code
                                && itemChild.category_id === itemPrd.category_id
                                && itemChild.id === itemPrd.id
                            ) {
                                itemChild.isChoose = false;
                                itemChild.packing_spec = itemChild.packing_spec_df ? itemChild.packing_spec_df : 1;
                            }
                        }
                        if (itemCategory.product_list_search?.length > 0) {
                            for (const itemChild of itemCategory.product_list_search) {
                                if (itemChild.jan_code === itemPrd.jan_code
                                    && itemChild.category_id === itemPrd.category_id
                                    && itemChild.id === itemPrd.id
                                ) {
                                    itemChild.isChoose = false;
                                    itemChild.packing_spec = itemChild.packing_spec_df ? itemChild.packing_spec_df : 1;
                                }
                            }
                        }
                    }
                }

                return list;
            })

            setValue((value) => {
                const list = value.dataValue.filter((item) => (
                    item.jan_code !== itemPrd.jan_code
                    && item.category_id !== itemPrd.category_id
                    && item.id !== itemPrd.id
                ))
                return {
                    dataValue: list
                };
            });

        } else {
            showDetailProduct(itemPrd, index3);
        };
    };

    const ClickBtnInPutAddProductToList = () => {
        setIsAddScanToList(true);
        setIsInput(false);
        setIsScans(false);
        setIsScrollTop(isScrollTop + 1);
        setValue((value) => {
            const list = value.dataValue.concat(dataSelectCategory);
            return {
                dataValue: list
            };
        });
    };

    const clickBtnScanAddPrdToList = () => {
        setIsInput(false);
        setIsScans(false);
        setIsAddScanToList(true);

        setValue((value) => {
            const list = value.dataValue.filter((item) => !item.dataScan).concat(dataSelectScanned);
            return {
                dataValue: list
            };
        });

        const valueContent = Array.from(new Set(dataSelectScanned)).filter((item) => item.isSubmit === false);
        if (valueContent.length) {
            setVisibleScanFail(true);
        };

        setIsScrollTop(isScrollTop + 1);
    };

    const setCountTooltipAdd =(value)=>{
        let newArr = [...barcodeReScan]
        let list = newArr.concat(value);
        setBarcodeReScan(list);
    }

    const setCountTooltipMinus =(value)=>{

        let ar = [...barcodeReScan];
        ar.splice(ar.indexOf(value), 1);
       
        setBarcodeReScan(ar);

    }

    const searChLogHistory = () => setIsSearchHistory(isSearchHistory +1);
    const onChangeDateFrom =(date, dateString)=> setDateFrom(dateString)
    const onChangeDateTo =(date, dateString)=>setDateTo(dateString)

    return (
        <>
            <AddProductPageView
                dataSelectScanned={dataSelectScanned}
                dataDfQuery={dataDfQuery}
                searched={searched}
                querys={querys}
                setAllProduct={setAllProduct}
                setDataSelectCategory={setDataSelectCategory}
                isAddScanToList={isAddScanToList}
                dataSelectCategory={dataSelectCategory}
                choosePrd={choosePrd}
                setChoosePrd={setChoosePrd}
                searchData={searchData}
                onSearchCategory={onSearchCategory}
                dataImg={dataImg}
                setDataImg={setDataImg}
                getImgUrlProduct={getImgUrlProduct}
                handleScroll={handleScroll}
                activeKey={activeKey}
                setIndexSlice={setIndexSlice}
                setActiveKey={setActiveKey}
                isInput={isInput}
                setIsInput={setIsInput}
                allProduct={allProduct}
                isScrollTop={isScrollTop}
                onClickBtnScan={onClickBtnScan}
                onClickBtnInput={onClickBtnInput}
                onClickBtnLog={onClickBtnLog}
                setIsScrollTop={setIsScrollTop}
                values={values}
                setValue={setValue}
                setBarcode={setBarcode}
                setBarcodeReScan={setBarcodeReScan}
                barcodeReScan={barcodeReScan}
                isScans={isScans}
                setIsScans={setIsScans}
                handleOpenCamera={() => setIsScans(true)}
                onClickGoBack={() => history.goBack()}
                localStorageParamUrl={localStorageParamUrl}
                showDetailProduct={showDetailProduct}
                showDetailPrdHistory={showDetailPrdHistory}
                deleteItemProduct={deleteItemProduct}
                onClickItemProduct={onClickItemProduct}
                submitListProduct={() => setVisibleUpdate(true)}
                ClickBtnInPutAddProductToList={ClickBtnInPutAddProductToList}
                clickBtnScanAddPrdToList={clickBtnScanAddPrdToList}
                isAddCateToList={isAddCateToList}
                setIsAddScanToList={setIsAddScanToList}
                isLogHistory={isLogHistory}
                searChLogHistory={searChLogHistory}
                setIsLogHistory={setIsLogHistory}
                dataHistory={dataHistory}
                onChangeDateFrom={onChangeDateFrom}
                onChangeDateTo={onChangeDateTo}
                dateFrom={dateFrom}
                dateNow={dateTo}
                dataImgHistory={dataImgHistory}
                deleteHistory={deleteHistory}
                setCountTooltipAdd={setCountTooltipAdd}
                setCountTooltipMinus={setCountTooltipMinus}
            />
            <ModalDetail
                janCode={janCode}
                categoryId={categoryId}
                idPrd={idPrd}
                visible={visible}
                setVisible={setVisible}
                inputValue={inputValue}
                dataInit={dataInit}
                setInputValue={setInputValue}
                submitChangePacking={submitChangePacking}
            />
            <ModalDetail
                idPrd={idPrdHistory}
                visible={visibleHistory}
                setVisible={setVisibleHistory}
                inputValue={inputHistory}
                dataInit={dataInitInput}
                setInputValue={setInputHistory}
                submitChangePacking={submitChangeHistory}
            />
            <ModalConfirm
                textTitle={'食品登録の確認'}
                textContent={'登録しますか'}
                textCancel={'キャンセル'}
                textSubmit={'はい'}
                visible={visibleUpdate}
                setVisible={setVisibleUpdate}
                submit={submitUpdateChart}
            />
            <ModalConfirm
                textTitle={'スキャン結果の警告！'}
                textContent={'スキャンしたJANコードが取扱商品に存在しません'}
                textContent2={'「カテゴリから探す」を利用しますか？'}
                textCancel={'キャンセル'}
                textSubmit={'はい'}
                visible={visibleScanFail}
                setVisible={setVisibleScanFail}
                submit={submitModalScanFail}
            />
        </>
    );
};

export default AddProductPage;

